import styled from 'styled-components';

export const SpinnerOverlay = styled.div`
  height: 60vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const elementWidth = ({width}) => {
    return width ? width : '50px'
}
const elementHeight = ({height}) => {
    return height ? height : '50px'
}
export const SpinnerContainer = styled.div`
  display: inline-block;
  width: ${elementWidth};
  height: ${elementHeight};
  border: 3px solid rgba(195, 195, 195, 0.6);
  border-radius: 50%;
  border-top-color: var(--lightblue);
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`;
